import { ProfileAdvancedSearchParams } from '../../profiles/search/profile-advanced-search-params.model';
import { MessageDraftProfileSearch } from './message-draft-profile-search.model';
import { ManualRecipient } from './manual-recipient.model';
import { MessageAttachment } from './message-attachment.model';
import { ReplaceEmailAddressOptionEnum } from './replace-email-address-option-enum.model';
import { ScheduleModeEnum } from './schedule-mode.enum';

export class Message {
  public MessageId: number = 0;
  public DraftMessageId: number = 0;
  public EventId: number = 0;
  public Subject: string = '';
  public Message: string = '';
  public SendFrom: string = '';
  public DateAndTimeToSend: Date = new Date();
  public DateCreated: Date = null;
  public DateCreatedUtc: Date = null;
  public MessageSent: boolean = false;
  public CommunicationsCount: number = 0;
  public CommunicationRecordsCreated: boolean = false;
  public DateAndTimeActuallySent: Date = new Date();
  public SendConfirmationTo: string = '';
  public Html: boolean = false;
  public Text: boolean = false;
  public Priority: number = 0;
  public QuantityOfMessagesSent: number = 0;
  public QuantityOfEmailsSent: number = 0;
  public QuantityOfFaxesSent: number = 0;
  public QuantityOfMessagesReceived: number = 0;
  public QuantityOfMessagesBad: number = 0;
  public CreateContact: boolean = false;
  public ContactType: string = '';
  public Contactee: string = '';
  public SmtpServer: string = '';
  public SelectSql: string = '';
  public IgnoreDoNotEmail: boolean = false;
  public ReplaceGeneralInfoAndMainContactInfo: boolean = false;
  public EliminateDupEmails: boolean = true;
  public ALT_ReportName: string = '';
  public ALT_FName: string = '';
  public ALT_LName: string = '';
  public ALT_Address1: string = '';
  public ALT_Address2: string = '';
  public ALT_City: string = '';
  public ALT_State: string = '';
  public ALT_Zip: string = '';
  public ALT_Email: string = '';
  public ALT_HomePhone: string = '';
  public ALT_WorkPhone: string = '';
  public ALT_Fax: string = '';
  public ALT_Website: string = '';
  public ALT_OpenInvoicesLink: string = '';
  public ALT_PortalLoginLink: string = '';
  public ALT_ExternalID: string = '';
  public ALT_CustomField: string = '';
  public ALT_DuesAnchorMonth: string = '';
  public ALT_DuesAmount: number = 0;
  public ALT_MembershipLevel: string = '';
  public ALT_NoOfUnits: number = 0;
  public ALT_ProfileType: string = '';
  public ALT_ManagementCompany: string = '';
  public ALT_Owner: string = '';
  public ALT_PrintableInvoice: string = '';
  public SendLocally: boolean = false;
  public SendFromDisplayName: string = '';
  public Attachments: MessageAttachment[] = [];
  public ReplaceEmailAddressOption: ReplaceEmailAddressOptionEnum = ReplaceEmailAddressOptionEnum.None;
  public ScheduleMode: ScheduleModeEnum = ScheduleModeEnum.Immediate;
  public OverrideDoNotEmailFlag: boolean;
  public UnsubscribeEmailAddress: string = '';
  public OpenRate: number = 0;
  public IsResend: boolean = false;

  // draft messages only, but here in case (non-draft) messages will need them
  public ProfileSearchParams: MessageDraftProfileSearch = null;
  public ManualRecipients: ManualRecipient[] = [];
  public Recurring: boolean = false;
  public CronExpression: string = '0 0 0 1/1 * ? *';
  public CronSummary: string = '';
  public EndDate: Date;
  public Scheduled: boolean = false;
  public LastMessageSentOn: Date = null;
  public LastMessageQueueCreatedOn: Date = null;
  public UpcomingSendDate: Date = null;
  public SendFromInfo: string[];
}
